import { useEffect, useState } from "react";
import api from "../../lib/api";
import { AiLocked, PlanCard } from "./AiPaywall";
import { useLocation } from "react-router-dom";
import { AiTab } from "./AiTab";
import { ChatTab } from "./ChatTab";
import { Bell, AlignLeft } from "lucide-react";
import { HistoryList } from "./HistoryMenu";
import { NotificationsList, MarkAllReadBtn } from "../NotificationsPanel";

const TABS = [
  { id: "ia", label: "IA" },
  { id: "chat", label: "Chat" },
];

export const AssistantPanel = ({ chatUnread = 0, appNotifs = [], onRefreshNotifs }) => {
  const notifUnread = appNotifs.filter((n) => !n.read_at).length;
  const loc = useLocation();
  const [tab, setTab] = useState("ia");
  const [resetKey, setResetKey] = useState(0);
  const [openSession, setOpenSession] = useState(null);
  const [billing, setBilling] = useState(null);
  useEffect(() => {
    api.get("/ai/billing").then(({ data }) => setBilling(data)).catch(() => {});
  }, []);
  const locked = billing && !billing.active;
  const cornerBtn = "absolute top-4 w-10 h-10 rounded-full grid place-items-center text-white transition-colors";
  const m = loc.pathname.match(/\/doctor\/pacientes\/([\w-]+)/);
  const routePatientId = m && m[1] !== "nuevo" ? m[1] : null;

  return (
    <aside className="hidden xl:flex w-[400px] shrink-0 pt-1 pb-4 pr-4 min-h-0" data-testid="cai-panel">
      <div className="cai-panel relative flex-1 min-h-0 rounded-[32px] overflow-hidden flex flex-col shadow-[0_20px_50px_-20px_rgba(111,140,222,0.6)]">
        <div className="relative z-10 flex-1 min-h-0 flex flex-col">
          <div className="relative flex items-center justify-center gap-2 px-5 pt-5 pb-3 text-white">
            <button
              type="button"
              onClick={() => setTab(tab === "history" ? "ia" : "history")}
              title="Conversaciones"
              data-testid="cai-new-chat"
              className={`${cornerBtn} left-4 ${tab === "history" ? "bg-white text-[#5B8FD0]" : "cai-glass cai-glass-hover"}`}
            >
              <AlignLeft className="w-4 h-4" strokeWidth={1.7} />
            </button>
            <button
              type="button"
              onClick={() => setTab(tab === "notif" ? "ia" : "notif")}
              title="Notificaciones"
              data-testid="cai-tab-notif"
              className={`${cornerBtn} right-4 ${tab === "notif" ? "bg-white text-[#5B8FD0]" : "cai-glass cai-glass-hover"}`}
            >
              <Bell className="w-4 h-4" strokeWidth={1.7} />
              {notifUnread > 0 && (
                <span data-testid="cai-notif-badge" className="absolute -top-1 -right-1 min-w-[17px] h-[17px] px-1 rounded-full bg-[#FF6B6B] text-white text-[9.5px] font-bold grid place-items-center">
                  {notifUnread > 9 ? "9+" : notifUnread}
                </span>
              )}
            </button>
            <span className="text-[14px]" data-testid="cai-title">ConsuDoctor AI</span>
            <span className="px-2.5 h-6 rounded-full border border-white/40 text-[11.5px] grid place-items-center">Beta</span>
          </div>
          <div className="mx-auto mb-3 cai-glass rounded-full p-1 flex gap-1" data-testid="cai-tabs">
            {TABS.map((t) => (
              <button
                key={t.id}
                type="button"
                onClick={() => setTab(t.id)}
                data-testid={`cai-tab-${t.id}`}
                className={`relative h-8 px-6 rounded-full text-[12.5px] font-medium transition-colors ${
                  tab === t.id ? "bg-white text-[#5B8FD0]" : "text-white hover:bg-white/15"
                }`}
              >
                {t.label}
                {t.id === "chat" && chatUnread > 0 && (
                  <span className="absolute -top-1 -right-1 min-w-[16px] h-4 px-1 rounded-full bg-[#FF6B6B] text-white text-[9.5px] font-bold grid place-items-center">
                    {chatUnread > 9 ? "9+" : chatUnread}
                  </span>
                )}
              </button>
            ))}
          </div>
          {tab === "chat" && <ChatTab />}
          {tab === "history" && locked && <AiLocked billing={billing} />}
          {tab === "history" && !locked && (
            <HistoryList
              footer={<PlanCard billing={billing} onChange={setBilling} />}
              onNew={() => { setTab("ia"); setResetKey((k) => k + 1); }}
              onOpen={(sess) => { setTab("ia"); setOpenSession({ ...sess, key: Date.now() }); }}
            />
          )}
          {tab === "notif" && (
            <div className="flex-1 min-h-0 flex flex-col cai-fade-in" data-testid="cai-notifications">
              <div className="px-5 pb-2 flex items-center justify-between">
                <span className="text-[10px] uppercase tracking-[0.18em] text-white/80">Notificaciones</span>
                <MarkAllReadBtn appNotifs={appNotifs} onRefreshNotifs={onRefreshNotifs} />
              </div>
              <NotificationsList
                unreadChat={chatUnread}
                appNotifs={appNotifs}
                onOpenChat={() => setTab("chat")}
                onRefreshNotifs={onRefreshNotifs}
              />
            </div>
          )}
          {tab === "ia" && locked && <AiLocked billing={billing} />}
          {!locked && (
          <div className={tab === "ia" ? "flex-1 min-h-0 flex flex-col" : "hidden"}>
            <AiTab routePatientId={routePatientId} resetKey={resetKey} openSession={openSession} />
          </div>
          )}
        </div>
      </div>
    </aside>
  );
};
